export const HIDE_ROAMING_LIMIT_INFO = "[BANNERS] HIDE_ROAMING_LIMIT_INFO";
export const HIDE_ALLOW_LIST_OVERRIDE_WARNING =
  "[BANNERS] HIDE_ALLOW_LIST_OVERRIDE_WARNING";
export const HIDE_PROFILE_LIMIT_WARNING =
  "[BANNERS] HIDE_PROFILE_LIMIT_WARNING";
export const HIDE_BLOCKED_LIMIT_WARNING =
  "[BANNERS] HIDE_BLOCKED_LIMIT_WARNING";

export interface BannersState {
  roamingLimitInfoVisible: boolean;
  allowListOverrideVisible: boolean;
  blockedLimitInfoVisible: boolean;
  profileLimitInfoVisible: Record<string, boolean>;
}

interface HideRoamingLimitInfoAction {
  type: typeof HIDE_ROAMING_LIMIT_INFO;
}

interface HideAllowListOverrideAction {
  type: typeof HIDE_ALLOW_LIST_OVERRIDE_WARNING;
}

interface HideBlockedLimitWarningAction {
  type: typeof HIDE_BLOCKED_LIMIT_WARNING;
}

interface HideProfileLimitWarningAction {
  type: typeof HIDE_PROFILE_LIMIT_WARNING;
  payload: string;
}

export type BannersActionType =
  | HideRoamingLimitInfoAction
  | HideAllowListOverrideAction
  | HideBlockedLimitWarningAction
  | HideProfileLimitWarningAction;
